
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Layout from "../../../components/Layout/MembersPortalLayout/MembersPortalLayout";

import { ApiResponse } from "../../../interface/IResponse";

import { LoanStatusDetails } from "../../../interface/MembersPortal/ILoan";

import helpers from "../../../helpers/index";

import LoanAmortizationTable from "../../../components/Table/MembersPortal/LoanAmortizationTable";

import loanService from "./loanService";


function LoanStatusDetailsPage() {

    const navigate = useNavigate();

    const [loanStatusDetails, setLoanStatusDetails] = useState<LoanStatusDetails | null>(null);

    const { loanId } = useParams<{ loanId: string }>();

    async function loadLoanStatusDetails() {

        try {

            var axiosResponse = await loanService.getLoanStatusDetails(Number(loanId));

            var response: ApiResponse<LoanStatusDetails> = axiosResponse.data;

            setLoanStatusDetails(response.result);

        }
        catch (err) {
            console.log('loadLoanStatusDetails err: ', err);

        }

    }

    useEffect(function () {
        (async () => {
            document.querySelector('.loader-container')?.classList.add('loader');

            await loadLoanStatusDetails();

            document.querySelector('.loader-container')?.classList.remove('loader');
        })();
    }, []);

    return (
        <Layout>

            <div className="title-container">
                <div>
                    <div className="dv-title">
                        <h1>Loan Status</h1>
                    </div>
                  <div>
                        <div className='label-2'>Loan Status:</div>
                        <div className='label-2 font-bold' id='lblLoanStatus'>
                           {
                              (() => {
                                switch(loanStatusDetails?.loanStatus) {
                                  case 0:
                                    return 'Ongoing';
                                  case 1:
                                    return 'Fully Paid';
                                  case 2:
                                    return 'Pending';
                                  default:
                                    return 'Declined';
                                }
                              })()
                            }
                        </div>
                    </div>
                </div>
                <div className="title-btn-container vertical-flex-bottom">
                   <div className="title-btn-container vertical-flex-bottom">
                    <button
                        type="button"
                        id="btnPreviewLoanApplicationForm"
                        onClick={() => {
                            navigate(`/Members/PreviewLoanApplicationForm/${loanId}`);
                        }}
                        className="btn-white-green-2 center-middle"
                    >
                        Preview Loan Application Form
                    </button>
                </div>
                    <button
                        type="button"
                        id="btnBack"
                        onClick={() => {
                            navigate("/Members/BorrowerDetails");

                        }}
                        className="btn-white-green-2 center-middle"
                    >
                        Back
                    </button>
                </div>
            </div>
            <br />
            <div className='content-container'>
                <div className='padding-container'>
                    <div>
                        <div className='label-2'>Name:</div>
                        <div className='label-2 font-bold' id='lblMemberName'>
                            {loanStatusDetails?.firstname} {loanStatusDetails?.lastname}
                        </div>
                        <div className='label-2'>Loan Amount:</div>
                        <div className='label-2 font-bold' id='lblLoanAmount'>
                            {Number(loanStatusDetails?.amountLoan).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </div>
                    </div>
                    <div>
                        <div className='label-2'>ID:</div>
                        <div className='label-2 font-bold' id='lblMembershipId'>
                            {loanStatusDetails?.membershipId}
                        </div>
                        <div className='label-2'>Terms:</div>
                        <div className='label-2 font-bold' id='lblTerm'>
                            {loanStatusDetails?.term} Months
                        </div>
                    </div>
                    <div>
                        <div className='label-2'>Email:</div>
                        <div className='label-2 font-bold' id='lblEmail'>
                            {loanStatusDetails?.email}
                        </div>
                        <div className='label-2'>Mode of Payment:</div>
                        <div className='label-2 font-bold' id='lblModeOfPayment'>
                            Monthly
                        </div>
                    </div>
                    <div>
                        <div className='label-2'>Amount Subscribed:</div>
                        <div className='label-2 font-bold' id='lblAmountSubscribed'>
                            {Number(loanStatusDetails?.amountSubscribe).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </div>
                        <div className='label-2'>Interest Rate:</div>
                        <div className='label-2 font-bold' id='lblInterestRate'>
                            {loanStatusDetails?.interestRate}%
                        </div>
                    </div>
                    <div>
                        <div className='label-2'>Initial Paid Up:</div>
                        <div className='label-2 font-bold' id='lblInitialPaidUp'>
                            {Number(loanStatusDetails?.initialPaidUp).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </div>
                        <div className='label-2'>Amortization Schedule:</div>
                        <div className='label-2 font-bold' id='lblAmortizationSchedule'>
                            {Number(loanStatusDetails?.amortizationSchedule).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </div>
                    </div>
                    <div>
                        {
                            (() => {
                                if(loanStatusDetails?.loanStatus === 0 || loanStatusDetails?.loanStatus === 1){
                                    return (
                                        <>
                                            <div className='label-2'>Date Released:</div>
                                            <div className='label-2 font-bold' id='lblDateReleased'>
                                                {helpers.formatLongDate(loanStatusDetails?.dateReleased)}
                                            </div>
                                        </>
                                    );
                                }
                                else {
                                    return (
                                       ""
                                    );

                                }
                          })()
                        }
                        <div className='label-2'>Service Fee:</div>
                        <div className='label-2 font-bold' id='lblServiceFee'>
                            {loanStatusDetails?.serviceFee}
                        </div>
                    </div>
                </div>
            </div>
            <br />

            <div className='content-container'>
                <div className='padding-container'>
                    <LoanAmortizationTable data={loanStatusDetails?.loanAmortizations ?? []} ></LoanAmortizationTable>
                </div>
            </div>
        </Layout>
    );
}


export default LoanStatusDetailsPage;